import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";
import { type AvatarKind, useAvatarUrl } from "./avatarUrl";

export function PersonAvatar({
    name,
    kind,
    id,
    className,
}: {
    name: string;
    kind: AvatarKind;
    id?: string;
    className?: string;
}) {
    const avatarUrl = useAvatarUrl(kind, id);

    return (
        <Avatar className={cn("size-9", className)}>
            <AvatarImage src={avatarUrl} alt="" />
            <AvatarFallback className="bg-zinc-100 text-xs text-zinc-600">
                {initials(name)}
            </AvatarFallback>
        </Avatar>
    );
}

function initials(name: string): string {
    return name
        .split(/\s+/)
        .filter(Boolean)
        .slice(-2)
        .map((part) => part[0]?.toUpperCase() ?? "")
        .join("");
}
